import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import { toast } from 'sonner';

const FALLBACK_MESSAGE =
  "We couldn't find a responder matching your preferences within 20 km. Would you like us to search for any available verified responder instead?";

export default function PreferenceFallback({ requestId, statusMessage, onUpdated, onCancel }) {
  const message = statusMessage || FALLBACK_MESSAGE;

  const searchWithout = async () => {
    try {
      const { data } = await api.post(`/service-requests/${requestId}/preference-fallback`, {
        decision: 'search_without',
      });
      toast.success('Searching with relaxed preferences');
      onUpdated?.(data.request);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not update search');
    }
  };

  const cancel = async () => {
    try {
      const { data } = await api.post(`/service-requests/${requestId}/preference-fallback`, {
        decision: 'cancel',
      });
      toast.success('Request cancelled');
      onCancel?.(data.request);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not cancel');
    }
  };

  return (
    <div className="resqly-card p-5 space-y-4" data-testid="preference-fallback">
      <p className="text-sm text-slate-700">{message}</p>
      <div className="flex flex-col gap-2">
        <Button
          data-testid="fallback-search-without"
          onClick={searchWithout}
          className="w-full bg-blue-700 hover:bg-blue-800"
        >
          Search without preferences
        </Button>
        <Button
          data-testid="fallback-cancel"
          variant="outline"
          onClick={cancel}
          className="w-full"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
